import PropTypes from 'prop-types'
import { intlShape } from 'react-intl'
import { METRIC, HYBRID, IMPERIAL } from './constants'

export const providerTypes = {
  intl: intlShape.isRequired,
  locale: PropTypes.string.isRequired,
  system: PropTypes.oneOf([ METRIC, HYBRID, IMPERIAL ]),
}

export const formatterTypes = {
  formatDistance: PropTypes.func,
  formatElevation: PropTypes.func,
  formatDuration: PropTypes.func,
  formatEnergy: PropTypes.func,
  formatHeartRate: PropTypes.func,
  formatPace: PropTypes.func,
  formatSpeed: PropTypes.func,
}

export const propTypes = {
  from: PropTypes.string,
  to: PropTypes.string,
  digits: PropTypes.number,
  numberOptions: PropTypes.object,
  value: PropTypes.number,
  unit: PropTypes.string,
}

